module.exports = __webpack_public_path__ + "static/media/study 220118.0cfaaa9d.png";